export class Timezone {
  name: string;
  description: string;
  abbreviation: string;
  offset: number;
  dstOffset: number;
  sortOrder: number;
  selected?: boolean;
}